import React from 'react';
import { BoxProps } from '@mui/material/Box';

import * as S from './styles';
interface ICardProps extends BoxProps {
  children: React.ReactNode;
  isBlocked?: boolean;
  id?: string;
}

function Card({ isBlocked = false, children, id, ...props }: ICardProps) {
  const generatedId = id ? `${id}` : 'id-general-container-card';
  return (
    <S.ContainerCard id={generatedId} isblocked={isBlocked || undefined} {...props}>
      {children}
    </S.ContainerCard>
  );
}

export default Card;